require("./categoriesModal.scss");

const PropTypes = require("prop-types");

// @ vendors
const React = require("react");
const PureRenderMixin = require("react-addons-pure-render-mixin");
const { connect } = require("react-redux");
// @ commons
const { formatText } = require("core/i18n").i18n;

// @ components
const OKModal = require("components/commons/OKModal/OKModal");
const OKSelect = require("components/commons/OKSelect/OKSelect");
// @ actions
const categoryActions = require("actions/categoryUpdate");
const {
    requestListCategories,
} = require("actions/expensesByCategories/expensesByCategoriesListCategories");

class CategoriesModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            categorySelected: null,
            subCategorySelected: null,
        };

        this.shouldComponentUpdate =
            PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleCategorySelection = this.handleCategorySelection.bind(this);
        this.handleSubcategorySelection =
            this.handleSubcategorySelection.bind(this);
    }

    componentDidMount() {
        const { requestListCategories, categoriesList } = this.props;

        if (categoriesList.size === 0) requestListCategories();
    }

    handleCategorySelection(evt) {
        const category = evt.value;

        this.setState({
            categorySelected: category,
            subCategorySelected: 0,
        });
    }

    handleSubcategorySelection(evt) {
        const subcategory = evt.value;

        this.setState({
            subCategorySelected: subcategory,
        });
    }

    getCategoriesSubCategoriesList = (code) => {
        const { categoriesList } = this.props;
        const categoryList = [];
        const subCategoriesList = [];

        if (categoriesList) {
            categoriesList.map((category) => {
                categoryList.push({
                    value: category.get("code"),
                    label: formatText(`categorized-${category.get("key")}`),
                });
                if (category.get("code") === code) {
                    category.get("subcategories").map((subcategory) => {
                        subCategoriesList.push({
                            categoryId: category.get("code"),
                            value: subcategory.get("code"),
                            label: formatText(
                                `categorized-${subcategory.get("key")}`
                            ),
                        });
                    });
                }
            });
        }

        return {
            categoryList,
            subCategoriesList,
        };
    };

    render() {
        const { categorySelected, subCategorySelected } = this.state;
        const {
            immCategoryUpdate,
            handleClose,
            handleChangeCategory,
            byCategory,
        } = this.props;
        const labelCategory = formatText("myMoneyTransactions-categorySelect");
        const labelSubcategory = formatText(
            "myMoneyTransactions-subcategorySelect"
        );
        const isUpdating = immCategoryUpdate.get("isUpdating");
        const categoryIdSelected =
            categorySelected || immCategoryUpdate.get("categoryCode");
        const subCategoryIdSelected =
            subCategorySelected || immCategoryUpdate.get("subCategoryCode");
        const categoriesList =
            this.getCategoriesSubCategoriesList(categoryIdSelected);
        const buttonIsDisabled = !categoryIdSelected || !subCategoryIdSelected;

        const content = (
            <React.Fragment>
                <div className="categories-modal__select-category">
                    <OKSelect
                        label={labelCategory}
                        options={categoriesList.categoryList}
                        value={categoryIdSelected}
                        searchable={false}
                        clearable={false}
                        onChange={this.handleCategorySelection}
                        disabled={isUpdating}
                    />
                </div>
                <div className="categories-modal__select-subcategory">
                    <OKSelect
                        label={labelSubcategory}
                        options={categoriesList.subCategoriesList}
                        value={subCategoryIdSelected}
                        searchable={false}
                        clearable={false}
                        onChange={this.handleSubcategorySelection}
                        disabled={isUpdating}
                    />
                </div>
            </React.Fragment>
        );

        return (
            <OKModal
                content={content}
                description={`"${immCategoryUpdate.get("description")}"`}
                footerType="navigation"
                isOpen={immCategoryUpdate.get("isOpen")}
                loading={isUpdating}
                onCloseCallback={handleClose}
                onPrimaryButtonClick={() =>
                    handleChangeCategory(
                        byCategory,
                        categoryIdSelected,
                        subCategoryIdSelected
                    )
                }
                onSecondaryButtonClick={handleClose}
                primaryButtonDisabled={buttonIsDisabled}
                primaryButtonText="myMoneyTransactions-changeCategory"
                secondaryButtonText="filterDate-cancel"
                title="myMoneyTransactions-modifyModal"
            />
        );
    }
}

CategoriesModal.propTypes = {
    immCategoryUpdate: PropTypes.object,
    handleChangeCategory: PropTypes.func,
    handleClose: PropTypes.func,
    requestListCategories: PropTypes.func.isRequired,
    setCategory: PropTypes.func,
    setSubcategory: PropTypes.func,
    byCategory: PropTypes.bool,
    categoriesList: PropTypes.object,
};

CategoriesModal.defaultProps = {
    byCategory: false,
};

module.exports.constructor = CategoriesModal;
module.exports.CategoriesModal = connect(
    (state) => ({
        immCategoryUpdate: state.categoryUpdate,
        categoriesList:
            state.expensesByCategoriesListCategories.get("categoriesList"),
        categoriesListFetching:
            state.expensesByCategoriesListCategories.get("fetching"),
        categoriesListError:
            state.expensesByCategoriesListCategories.get("error"),
    }),
    {
        requestListCategories,
        handleClose: categoryActions.close,
        setCategory: categoryActions.setCategory,
        setSubcategory: categoryActions.setSubcategory,
        handleChangeCategory: categoryActions.requestChangeCategory,
    }
)(CategoriesModal);
